(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(event) {
        const href = anchor.getAttribute('href');
        if (!href || href === '#') return;

        let target = null;
        try {
          target = document.querySelector(href);
        } catch (error) {
          return;
        }
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    const animatedElements = Array.from(document.querySelectorAll('[data-animate]'));
    if (reduceMotion || !('IntersectionObserver' in window)) {
      animatedElements.forEach(function(element) {
        element.classList.add('fade-in');
      });
    } else {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('fade-in');
          observer.unobserve(entry.target);
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      animatedElements.forEach(function(element) {
        observer.observe(element);
      });
    }

    if (!reduceMotion) {
      const parallaxElements = Array.from(document.querySelectorAll('[data-parallax]'));
      let animationFrame = null;

      function updateParallax() {
        const scrolled = window.scrollY;
        parallaxElements.forEach(function(element) {
          const configuredSpeed = Number(element.dataset.parallax);
          const speed = Number.isFinite(configuredSpeed) ? configuredSpeed : 0.5;
          element.style.transform = 'translateY(' + (scrolled * speed) + 'px)';
        });
        animationFrame = null;
      }

      if (parallaxElements.length) {
        window.addEventListener('scroll', function() {
          if (animationFrame) return;
          animationFrame = window.requestAnimationFrame(updateParallax);
        }, { passive: true });
      }
    }
  });
})();
